import React from 'react';

import { Hidden } from '@material-ui/core';

import { IReportEntity } from '../../../state/types';

import {
    DownloadAction,
    PreviewAction,
    ExternalLinkAction,
} from '../../ButtonActions/ButtonActions';
import { useStyles } from './Themable.hooks';

interface IOwnProps {
    entity: IReportEntity;
    customRender?: React.ReactNode;
}

const ActionEntity = ({ entity, customRender }: IOwnProps) => {
    const classes = useStyles();

    const {
        preview: previewAction,
        download: downloadAction,
        externalLink: externalLinkAction,
    } = entity.actions ?? {};

    const entityName =
        typeof entity.value === 'object' ? entity.value.name : '';

    const linkEntity =
        String(entity.value).startsWith('http') &&
        entity.type !== 'externalLink';

    if (!entity.label) return <></>;

    return (
        <span className={classes.attachment}>
            {downloadAction && (
                <DownloadAction
                    classes={classes}
                    api={downloadAction.api}
                    name={entityName}
                    isMovie={(entity.value as { isMovie: boolean }).isMovie}
                />
            )}
            {previewAction && (
                <Hidden smDown={true}>
                    <PreviewAction classes={classes} api={previewAction.api} />
                </Hidden>
            )}
            {externalLinkAction && (
                <ExternalLinkAction
                    classes={classes}
                    url={externalLinkAction.url}
                />
            )}

            {customRender}

            {linkEntity && (
                <ExternalLinkAction
                    classes={classes}
                    url={entity.value.toString()}
                    withCopy
                />
            )}
        </span>
    );
};

export default ActionEntity;
